import React from "react";
import { MenuItem, ListItemText } from "@mui/material";
import { noResultsTextStyles } from "../styles/MultiSelectNoResults.styles";

export const MultiSelectNoResults: React.FC = () => {
  return (
    <MenuItem disabled value=""> {/* Add empty value to prevent MUI errors */}
      <ListItemText
        primary="No data found"
        sx={noResultsTextStyles}
      />
    </MenuItem>
  );
}; 